import { render } from "./PartnersSection.vue?vue&type=template&id=40be6868&scoped=true"
import script from "./PartnersSection.vue?vue&type=script&lang=js"
export * from "./PartnersSection.vue?vue&type=script&lang=js"

import "./PartnersSection.vue?vue&type=style&index=0&id=40be6868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40be6868"]])

export default __exports__